import React, {useEffect, useState} from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
} from "antd";
import {catalogMedicineStoreService} from "api";
import {InputFields} from "components/common";
import {dataFields} from "./config";
import Notification from "components/common/notification/notification";

const ModalContent = props => {
  const {data, closeModal, type, getListStore, nameCatalog} = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);
  const addStore = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
        kieuKho: "TT",
        loaiKhoId: 0,
        nhomKho: "TH",
      };
      const res = await catalogMedicineStoreService.addStore(params);
      setLoading(false);
      closeModal();

      await getListStore();
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi thêm mới ${nameCatalog}`
      );
    }
  };
  const updateStore = async () => {
    setLoading(true);
    try {
      const params = {
        ...form.getFieldsValue(),
        kieuKho: "TT",
        loaiKhoId: 0,
        nhomKho: "TH",
      };
      const res = await catalogMedicineStoreService.updateStore(params);
      setLoading(false);
      closeModal();
      await getListStore();
    } catch (error) {
      setLoading(false);
      Notification(
        "error",
        error?.response?.data ?? `Đã có lỗi khi sửa thông tin ${nameCatalog}`
      );
    }
  };
  const onFinish = values => {
    if (type == "Thêm") {
      addStore();
    } else {
      updateStore();
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{width: "100%"}}>
            <Row gutter={[16, 16]}>
              <InputFields data={dataFields}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal}>Hủy</Button>
                  <Button htmlType="submit" type="primary">
                    Xác nhận
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default ModalContent;
